import { render, staticRenderFns } from "./NewSubmissionModal.vue?vue&type=template&id=266e96c7&"
import script from "./NewSubmissionModal.vue?vue&type=script&lang=js&"
export * from "./NewSubmissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewSubmissionModal.vue"
export default component.exports